import React from "react";
import { ServiceReviews } from "../../types/serviceDetail";

interface Props {
  serviceReview?: ServiceReviews;
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceReview: React.FC<Props> = ({
  serviceReview,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const renderTitle = (title: string | null) => {
    if (!title) return null;
    const TitleTag = isPage ? "h3" : "p";
    return (
      <TitleTag
        className="text-center font-16 text-black ff-semibold mb-4"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    );
  };

  const renderLine = (line: string | null) => {
    if (!line) return null;
    return (
      <p
        className="font-12 text-grey ff-normal text-center"
        dangerouslySetInnerHTML={{ __html: line }}
      />
    );
  };

  return (
    <div className="py-4">
      {renderTitle(sectionTitle)}
      {renderLine(line)}

      {serviceReview?.reviewScript && (
        <div
          dangerouslySetInnerHTML={{ __html: serviceReview.reviewScript }}
        />
      )}
    </div>
  );
};

export default ServiceReview;